module.exports = __webpack_public_path__ + "static/media/enartists.d6734d47.png";